export default {
  slide: ({ src, isMobile }) => ({
    p: isMobile ? 2 : '3vw',
    width: '100%',
    height: '100%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `url(${src})`,
    borderRadius: isMobile ? '10px' : '20px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: isMobile ? 'flex-end' : 'center',
    flexDirection: 'column',
  }),
};
